<!-- Header -->
<!-- SPinner Modal -->
<div id="spinnerModal" class="modalSpinner">
        <div class="spinner-border blueText spinnerPosition">
        </div>
</div>
<!-- End spinner Modal -->

  <!-- login Modal -->
  <app-myharrellsloginprompt></app-myharrellsloginprompt>
  <!-- End login Modal -->


<div class="container-fluid greenBackground"
        *ngIf="(this.myHarrellsService.displayMobileMenu && (this.myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm'))"
        style="position:fixed; top:0px; left:0px; width:100%; height:100%; z-index: 1000; padding-right:40px; overflow-y:scroll">
        <div class="col-12" style="text-align: right;padding-right:10px; margin-top:10px" (click)="ToggleMobileMenu()">
                <h1 style="position:fixed; right:40px; top:0px; font-size:40px; color:white "> X </h1>
        </div>
        <div class="row g-0">
                <a href="/">
                        <h3 class="Din2014Regular whiteText" style="font-size:24px; text-decoration: underline">HOME
                        </h3>
                </a>
                <h3 class="Din2014Regular whiteText mobileMenuLargeLink">PEOPLE</h3>
                <a href="/findrep">
                        <h3 class="Din2014Regular whiteText mobileMenuSmallLink">Find Your Rep</h3>
                </a>
                <a href="/about">
                        <h3 class="Din2014Regular whiteText mobileMenuSmallLink">About</h3>
                </a>
                <a href="/careers">
                        <h3 class="Din2014Regular whiteText mobileMenuSmallLink">Careers</h3>
                </a>
                <a href="/contact">
                        <h3 class="Din2014Regular whiteText mobileMenuSmallLink">Contact</h3>
                </a>
                <a href="/teams">
                        <h3 class="Din2014Regular whiteText mobileMenuSmallLink">Team</h3>
                </a>
                <a href="/products">
                        <h3 class="Din2014Regular whiteText mobileMenuLargeLink" style="text-decoration: underline">
                                PRODUCTS
                        </h3>
                </a>
                <h3 class="Din2014Regular whiteText mobileMenuLargeLink">MARKETS</h3>
                <a href="/golf">
                        <h3 class="Din2014Regular whiteText mobileMenuSmallLink">Golf Courses</h3>
                </a>
                <a href="/lawn">
                        <h3 class="Din2014Regular whiteText mobileMenuSmallLink">Lawn + Landscape</h3>
                </a>
                <a href="/horticulture">
                        <h3 class="Din2014Regular whiteText mobileMenuSmallLink">Horticulture</h3>
                </a>
                <a href="/turf">
                        <h3 class="Din2014Regular whiteText mobileMenuSmallLink">Sports Turf</h3>
                </a>
                <a href="/specialty">
                        <h3 class="Din2014Regular whiteText mobileMenuSmallLink">Specialty Ag</h3>
                </a>
                <h3 class="Din2014Regular whiteText mobileMenuLargeLink">RESOURCES</h3>
                <a href="/myharrellslogin">
                        <h3 class="Din2014Regular whiteText mobileMenuSmallLink">myHarrells</h3>
                </a>
                <a href="/knowledge">
                        <h3 class="Din2014Regular whiteText mobileMenuSmallLink">Blogs & More</h3>
                </a>
                <a href="/education">
                        <h3 class="Din2014Regular whiteText mobileMenuSmallLink">Online Education</h3>
                </a>
                <a href="/calculators">
                        <h3 class="Din2014Regular whiteText mobileMenuSmallLink">Tools & Calculators</h3>
                </a>
                <a href="/forms">
                        <h3 class="Din2014Regular whiteText mobileMenuSmallLink">Forms & Credit Applications</h3>
                </a>
                <a href="/locations">
                        <h3 class="Din2014Regular whiteText mobileMenuLargeLink" style="text-decoration: underline;">
                                LOCATIONS</h3>
                </a>


                <a *ngFor="let x of allWarehouses" href="{{'/locations?filter=' + x.name}}">
                        <h3 class="Din2014Regular whiteText mobileMenuSmallLink">
                                {{x.alt_name}}</h3>
                </a>




        </div>

</div>
<!-- not showing the header if the user is logged in and the viewport is xs or sm -->
<div class="row g-0" (mouseenter)="this.dotComService.DisplaySubMenu('')"
        *ngIf="!(this.myHarrellsService.loggedInMyHarrellsUser && (this.myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm'))">


        <div class="alert alert-warning" role="alert" *ngIf="dotComService.displayWarning"
                style="position:fixed; bottom:45%; width:90%; margin-left:5%">
                <h6 style="display:inline" [innerHTML]="this.dotComService.warningText"></h6>
                <h6 style="cursor:pointer;display:inline;float:right;" (click)="HideWarningAlert()">X</h6>
        </div>
        <div class="alert alert-success" role="alert" *ngIf="dotComService.displaySuccess"
                style="position:fixed; bottom:45%; width:90%; margin-left:5%">
                <h6 style="display:inline" [innerHTML]="this.dotComService.successText"></h6>
                <h6 style="cursor:pointer;display:inline;float:right;" (click)="HideSuccessAlert()">X</h6>
        </div>
        <div class="alert alert-warning" role="alert" *ngIf="dotComService.displayLabelNotice"
                style="position:fixed; bottom:45%; width:90%; margin-left:5%">
                <h6 style="display:inline">No Label found! Please contact inventory&#64;harrells.com to see if a Label
                        is
                        available for {{dotComService.product.WebName}}</h6>
                <h6 style="cursor:pointer;display:inline;float:right;" (click)="HideLabelNotFoundNotice()">X</h6>
        </div>
        <div class="alert alert-warning" role="alert" *ngIf="dotComService.displaySDSNotice"
                style="position:fixed; bottom:45%; width:90%; margin-left:5%">
                <h6 style="display:inline">No SDS found! Please contact inventory&#64;harrells.com to see if a SDS is
                        available for {{dotComService.product.WebName}}</h6>
                <h6 style="cursor:pointer;display:inline;float:right;" (click)="HideSDSNotFoundNotice()">X</h6>
        </div>
        <!--cart icon only shows when logged in, selected a customer, address code AND SELECTED ONLINE ORDERING OR BILL AND HOLD -->
        <!-- this is because some users have both olo and bh and we need to know which one they are using -->
        <div class="greenBackground" (click)="GoToCart()"
                *ngIf="this.myHarrellsService.customerNmbrSelected && this.myHarrellsService.customerAddressCodeSelected && this.myHarrellsService.onlineOrderingInEffect"
                style="cursor:pointer; position: fixed;right: 20px; top:20px; width: 50px;height: 50px; border-radius: 25px;padding-left: 9px; padding-top: 7px;">
                <img src="{{this.pageImagePaths + 'shopping-cart-white.png'}}" alt="Cart Icon"
                        style="display:inline;height:30px;width:30px;margin-top:10px">
                <h6 class="DIN2014Bold whiteText" style="position:relative; left:10px; top:-46px; font-size:19px;">
                        {{this.dotComService.cartCount}}</h6>
        </div>
        <!-- hamburger menu start - NOT THE MY HARRELLS HAMBURGER MENU SKIPPY -->
        <!-- <div class="off-screen-menu d-xs-block d-sm-none">
                <h3 class="Din2014Regular whiteText" style="font-size:28px">People</h3>
                <a href="/products"><h3 class="Din2014Regular whiteText" style="font-size:28px">Products</h3></a>
        </div> -->

        <nav *ngIf="!this.myHarrellsService.onlineOrderingInEffect" (click)="ToggleMobileMenu()">
                <div class="ham-menu d-xs-block d-sm-none">
                        <span></span>
                        <span></span>
                        <span></span>
                </div>
        </nav>
        <!-- hamburger menu end -->

        <div class="col-lg-4 blueBackground" *ngIf="!this.myHarrellsService.onlineOrderingInEffect">
                <h6 style="padding-top:3px"><a class="greenBackground myHarrellsLogo" href='/myharrellslogin'><span
                                        class="Caecilia86HeavyItalic whiteText mt-1"
                                        style="font-size:17px; font-weight:850; margin-right:19px; margin-left:19px">myHarrell's</span></a>
                </h6>
        </div>

        <div class="col-lg-4 blueBackground" *ngIf="!this.myHarrellsService.onlineOrderingInEffect"
                style="margin-top: -1px; margin-bottom: -1px;">
                <a href="/home"><img class="centerHorizontal mt-3 mb-3  harrellsTopLogoAnchor"
                                src="{{this.pageImagePaths + 'harrells-logo-header.png'}}" alt="Harrells Logo"></a>
        </div>
        <div class="col-lg-4 blueBackground"></div>

        <div class="col-lg-12 blueBackground" *ngIf="!this.myHarrellsService.onlineOrderingInEffect"
                style="padding-right:5%; margin-top:-15px; text-align: right;height:37px">
                <h3 class="col d-none d-md-inline" style="display:inline-flex;height:36px;width:235px">
                        <a class="DINNextLTPro-Black lightBlueBackground blueText findYourRepHeader"
                                style="font-size: 20px;padding-top: 10px;padding-bottom: 6px;padding-left: 22px;padding-right: 22px;"
                                href='/findrep'>FIND YOUR
                                REP</a>
                </h3>

                <input Class="d-none d-md-inline DINNextLTPro-Black blueText"
                        style="text-align:left;position:relative;border:none; bottom:0px;display:inline;font-size:20px;height:36px; width:180px;margin-left:10px;padding-right:22px; padding-left:22px; padding-top:6px"
                        placeholder="SEARCH" (keyup)="QuickFilterChanged()" (keyup.enter)="GoToMainSearch()"
                        [(ngModel)]="this.dotComService.quickSearchInput">
                <img class="d-none d-md-inline " src="{{this.resourceImagePaths + 'search-normal.png'}}"
                        alt="Search Icon" (click)="GoToMainSearch()"
                        style="position:relative; display:inline;height:20px;width:20px;margin-left: -35px; margin-top:-5px">

                <div class="whiteBackground blackText"
                        *ngIf="productResults.length>0 || empResults.length>0 || blogResults.length>0 || invoiceResults.length>0 || educationResults.length>0"
                        style="position:fixed; right:1%;z-index: 2; min-width:280px; max-width:280px; overflow: auto; max-height:70vh; border:solid 1px lightgrey">
                        <!-- products results if any -->
                        <div *ngIf="productResults.length>0" class="row g-0 mb-2"
                                style="margin-left:10px; margin-right:10px;">
                                <h4 *ngIf="productResults.length>0" class="Caecilia76BoldItalic blackText"
                                        style="text-align:left; font-size:20px; font-weight:700; margin-top:20px;">
                                        Products
                                </h4>
                                <div *ngFor="let result of this.productResults" class="col-12">
                                        <div class="row g-0" (click)="ViewProductsDetail(result)">
                                                <div style="text-align: left;">
                                                        <h6 class="DIN2014Regular"
                                                                style="margin-top:10px; cursor:pointer; font-size:16px;font-weight:400; line-height: 25px;letter-spacing: .38px;">
                                                                {{result.WebName}}</h6>
                                                </div>
                                        </div>
                                        <div class="row g-0" (click)="ViewProductsDetail(result)">
                                                <div style="text-align: left;">
                                                        <h6 class="DIN2014Regular"
                                                                style="cursor:pointer; font-size:16px;font-weight:400; line-height: 25px;letter-spacing: .38px;">
                                                                {{result.ItemNmbr}}</h6>
                                                </div>
                                        </div>
                                        <div class="row g-0" style="border-bottom:1px solid grey">
                                                <div style="width:50%;text-align: center;">
                                                        <h6 class="DIN2014Regular blueText" (click)="GetSDS(result)"
                                                                style="cursor:pointer; text-decoration: underline; font-size:11px;font-weight:400; line-height: 19.2px;letter-spacing: .38px;">
                                                                SDS</h6>

                                                </div>
                                                <div style="width:50%;text-align: center;">
                                                        <h6 class="DIN2014Regular blueText" (click)="GetLabel(result)"
                                                                style="cursor:pointer; text-decoration: underline; font-size:11px;font-weight:400; line-height: 19.2px;letter-spacing: .38px;">
                                                                Label</h6>

                                                </div>
                                        </div>
                                </div>
                        </div>

                        <!-- emp results if any -->
                        <div *ngIf="empResults.length>0 && productResults.length == 0" style="min-height:10px"></div>

                        <div *ngIf="empResults.length>0" class="row g-0 mb-2"
                                style="margin-left:10px; margin-right:10px">
                                <h4 *ngIf="empResults.length>0" class="Caecilia76BoldItalic blackText"
                                        style="text-align:left; font-size:20px; font-weight:700; margin-bottom:0px; margin-top:10px">
                                        Employees
                                </h4>
                                <div *ngFor="let result of this.empResults" class="col-12">
                                        <div class="row g-0" (click)="GoToRep(result)"
                                                style="border-bottom:1px solid grey">
                                                <div style="width:auto">
                                                        <h6 class="DIN2014Regular"
                                                                style="margin-top:10px; text-align:left;font-size:16px;font-weight:400; line-height: 25px;letter-spacing: .38px;">
                                                                {{result.Name}}</h6>
                                                </div>
                                        </div>
                                </div>
                        </div>

                        <!-- blog results if any -->
                        <div *ngIf="blogResults.length>0 && productResults.length == 0 && empResults.length == 0"
                                style="min-height:10px"></div>
                        <div *ngIf="blogResults.length>0" class="row g-0 mb-2"
                                style="margin-left:10px; margin-right:10px">
                                <h4 *ngIf="blogResults.length>0" class="Caecilia76BoldItalic blackText"
                                        style="text-align:left; font-size:20px; font-weight:700; margin-bottom:0px; margin-top:10px">
                                        Blogs
                                </h4>
                                <div *ngFor="let result of this.blogResults" class="col-12">
                                        <div (click)="GoToBlog(result)" class="row g-0"
                                                style="border-bottom:1px solid grey">
                                                <div style="width:auto">
                                                        <h6 class="DIN2014Regular"
                                                                style="margin-top:10px; text-align:left; cursor:pointer; text-align:left;font-size:16px;font-weight:400; line-height: 25px;letter-spacing: .38px;"
                                                                [innerHTML]="result.Name"></h6>
                                                </div>
                                        </div>
                                </div>
                        </div>

                        <!-- education results if any -->
                        <div *ngIf="educationResults.length>0 && blogResults.length == 0 && productResults.length == 0 && empResults.length == 0"
                                style="min-height:10px"></div>
                        <div *ngIf="educationResults.length>0" class="row g-0 mb-2"
                                style="margin-left:10px; margin-right:10px">
                                <h4 *ngIf="educationResults.length>0" class="Caecilia76BoldItalic blackText"
                                        style="text-align:left; font-size:20px; font-weight:700; margin-bottom:0px; margin-top:10px">
                                        Education
                                </h4>
                                <div *ngFor="let result of this.educationResults" class="col-12">
                                        <div (click)="GoToEducationPostSearchPage(result)" class="row g-0"
                                                style="border-bottom:1px solid grey">
                                                <div style="width:auto">
                                                        <h6 class="DIN2014Regular"
                                                                style="margin-top:10px; text-align:left; cursor:pointer; text-align:left;font-size:16px;font-weight:400; line-height: 25px;letter-spacing: .38px;"
                                                                [innerHTML]="result.Name"></h6>
                                                </div>
                                        </div>
                                </div>
                        </div>                        

                        <!-- invoice results if any -->
                        <div *ngIf="invoiceResults.length>0" class="row g-0 mb-2"
                                style="margin-left:10px; margin-right:10px">
                                <h4 *ngIf="invoiceResults.length>0" class="Caecilia76BoldItalic blackText"
                                        style="text-align:left; font-size:20px; font-weight:700; margin-bottom:0px; margin-top:20px">
                                        Invoices
                                </h4>
                                <div *ngFor="let result of this.invoiceResults" class="col-12">
                                        <div class="row g-0" style="border-bottom:1px solid grey">
                                                <div style="width:auto"
                                                        (click)="OpenPdfDoc('Invoice',result.SOPNumber)">
                                                        <h6 class="DIN2014Regular"
                                                                style="cursor:pointer; text-align:left;font-size:16px;font-weight:400; line-height: 25px;letter-spacing: .38px;margin-top:20px"
                                                                [innerHTML]="result.SOPNumber"></h6>
                                                        <h6 class="DIN2014Regular"
                                                                style="cursor:pointer; text-align:left;font-size:16px;font-weight:400; line-height: 25px;letter-spacing: .38px;">
                                                                {{result.DocumentDate}}</h6>
                                                </div>
                                        </div>
                                </div>
                        </div>
                </div>
                <!-- <h3 class="col" style="display:inline; padding-right:2px">
                        <a (click)="GoToMainSearch()">
                                <img src="{{this.pageImagePaths + 'search-white.png'}}" alt="Search Icon"
                                        style="display:inline;height:20px;width:20px;">
                        </a>
                </h3> -->
        </div>
</div>

<div class="d-none d-md-block" style="position:relative" *ngIf="!this.myHarrellsService.onlineOrderingInEffect">
        <!-- menu bar -->
        <div class="row g-0">
                <div class="cremeBackground text-center">
                        <div class="row g-0" style="max-width:820px; margin:auto; padding-top:9px; padding-bottom:14px">
                                <div class="col">
                                        <h4 style="width:20%; display:inline;cursor:default"
                                                (mouseenter)="this.dotComService.DisplaySubMenu('people'); this.dotComService.LastMainMenuHovered('people')">
                                                <!-- <a class="DIN2014Regular blueText" style="font-size:14pt"
                                                        href='/people'>PEOPLE</a> -->
                                                <!-- at the current time there is no page for the market mega menu.  the user must pick a submenu -->
                                                <span class="DIN2014Regular blueText" style="font-size:14pt"
                                                        [ngClass]="this.dotComService.activeMainMenu =='people' ? 'activeLink': '' "
                                                        href=''>PEOPLE</span>
                                        </h4>
                                </div>
                                <div class="col">
                                        <h4 style="width:20%; display:inline"
                                                (mouseenter)="this.dotComService.DisplaySubMenu('products'); this.dotComService.LastMainMenuHovered('products')">
                                                <a class="DIN2014Regular blueText" style="font-size:14pt"
                                                        [ngClass]="this.dotComService.activeMainMenu =='products' ? 'activeLink': '' "
                                                        href='/products'>PRODUCTS</a>
                                        </h4>
                                </div>
                                <div class="col">
                                        <h4 style="width:20%; display:inline;cursor:default"
                                                (mouseenter)="this.dotComService.DisplaySubMenu('markets'); this.dotComService.LastMainMenuHovered('markets')">
                                                <!-- <a class="DIN2014Regular blueText" style="font-size:14pt" href='/markets'>MARKET </a> -->
                                                <!-- at the current time there is no page for the market mega menu.  the user must pick a submenu -->
                                                <span class="DIN2014Regular blueText" style="font-size:14pt"
                                                        [ngClass]="this.dotComService.activeMainMenu =='markets' ? 'activeLink': '' "
                                                        href=''>MARKETS</span>
                                        </h4>
                                </div>
                                <div class="col">
                                        <h4 style="width:20%; display:inline;cursor:default"
                                                (mouseenter)="this.dotComService.DisplaySubMenu('resources');this.dotComService.LastMainMenuHovered('resources')">
                                                <!-- <a class="DIN2014Regular blueText" style="font-size:14pt" href='/resources'>RESOURCES</a> -->
                                                <!-- at the current time there is no page for the market mega menu.  the user must pick a submenu -->
                                                <span class="DIN2014Regular blueText" style="font-size:14pt"
                                                        [ngClass]="this.dotComService.activeMainMenu =='resources' ? 'activeLink': '' "
                                                        href=''>RESOURCES</span>
                                        </h4>
                                </div>
                                <div class="col">
                                        <!-- <h4 style="width:20%; display:inline"
                                                (mouseenter)="this.dotComService.DisplaySubMenu('locations');this.dotComService.LastMainMenuHovered('locations')"
                                                (click)="this.dotComService.LastMainMenuHovered('locations')">
                                                <a class="DIN2014Regular blueText" style="font-size:14pt"
                                                        [ngClass]="this.dotComService.activeMainMenu =='locations' ? 'activeLink': '' "
                                                        href='/locations'>LOCATIONS</a>
                                        </h4> -->
                                        <h4 style="width:20%; display:inline"
                                                (mouseenter)="this.dotComService.DisplaySubMenu('locations'); this.dotComService.LastMainMenuHovered('locations')">
                                                <a class="DIN2014Regular blueText" style="font-size:14pt"
                                                        [ngClass]="this.dotComService.activeMainMenu =='locations' ? 'activeLink': '' "
                                                        href='/locations'>LOCATIONS</a>
                                        </h4>
                                </div>
                        </div>
                </div>
        </div>

        <!-- submenus -->
        <div class="greenBackground whiteText text-center" style="position:absolute; width:100%; z-index: 3">
                <div class="row g-0 mt-5 mb-5" *ngIf="this.dotComService.activeSubMenu == 'people'">
                        <div style="width:30%"></div>
                        <div style="width:15%">
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0" href='/findrep'>FIND
                                                YOUR
                                                REP</a>
                                </h4>
                        </div>
                        <div style="width:15%">
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0" href='/about'>ABOUT</a>
                                </h4>
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0" href='/careers'>CAREERS</a>
                                </h4>

                        </div>
                        <div style="width:15%">
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0" href='/teams'>TEAM</a>
                                </h4>
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0" href='/contact'>CONTACT</a>
                                </h4>
                                <!-- <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0" href='/resources'>DIRECTORS OF
                                                AGRONOMY</a></h4> -->
                        </div>
                        <div style="width:25%"></div>
                </div>
                <div class="row g-0 mt-5 mb-5" *ngIf="this.dotComService.activeSubMenu == 'products'">
                        <div style="width:30%"></div>
                        <div style="width:15%">
                                <!-- <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0;" href='http://polyon.com'
                                                target="_blank">POLYON®</a>
                                </h4> -->
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0"
                                                href='/products?filter=Polyon'>POLYON®</a></h4>
                                <!-- <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0" href='/peat'>PEAT</a>
                                </h4> -->
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText"
                                                style="font-size:14pt; line-height:1.0; text-decoration: none; cursor: pointer;"
                                                (mouseenter)="isHovered = true" (mouseleave)="isHovered = false"
                                                [ngClass]="{'hover-class': isHovered}"
                                                (click)="GetCategoryGroupItems('Granular Fertilizer')">GRANULAR
                                                FERTILIZER</a></h4>
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0"
                                                href='/products?filter=Foliars'>FOLIAR
                                                FERTILIZER</a></h4>
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0"
                                                href='/products?filter=Soluble'>SOLUBLE
                                                FERTILIZER</a></h4>
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0"
                                                href='/products?filter=Fungicide'>FUNGICIDES</a>
                                </h4>
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0"
                                                href='/products?filter=Herbicide'>HERBICIDES</a>
                                </h4>
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0"
                                                href='/products?filter=Insecticide'>INSECTICIDES</a>
                                </h4>
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0"
                                                href='/products?filter=Biological'>BIOLOGICALS</a>
                                </h4>
                        </div>
                        <div style="width:15%">
                                <!-- <h4 class="DIN2014Regular whiteText " style="font-size:14pt; line-height:1.0">
                                </h4> -->
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0"
                                                href='/products?filter=Paint-Dye'>PIGMENTS &
                                                PAINTS</a></h4>
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0"
                                                href='/products?filter=Adjuvants'>ADJUVANTS</a>
                                </h4>
                                <!-- <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0" href='/resources'>WATER
                                                CONDITIONING</a></h4> -->
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0"
                                                href='/products?filter=Wetting Agents'>WETTING
                                                AGENTS</a>
                                </h4>
                                <!-- <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0" href='/resources'>SOIL
                                                CONDITIONING</a></h4> -->
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0"
                                                href='/products?filter=Amendments'>SOIL
                                                AMENDMENTS</a></h4>
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0"
                                                href='/products?filter=Seed'>SEED</a></h4>
                                <!-- <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0" href='/resources'>OTHER</a></h4> -->
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0" href='/products'>ALL</a>
                                </h4>
                        </div>
                        <div style="width:15%">
                                <!-- <h4 class="DIN2014Regular whiteText "
                                        style="text-align:left; font-size:14pt; line-height:1.0">
                                        <U>BRANDS</U>
                                </h4> -->
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0"
                                                href='/products?filter=Harrell&#39;s'>HARRELL'S</a>
                                </h4>
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0"
                                                href='/products?filter=Envu'>ENVU</a></h4>
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0"
                                                href='/products?filter=BASF'>BASF</a></h4>
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0"
                                                href='/products?filter=Syngenta'>SYNGENTA</a>
                                </h4>
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0"
                                                href='/products?filter=FMC'>FMC</a></h4>
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0"
                                                href='/products?filter=Nufarm'>NUFARM</a>
                                </h4>
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0"
                                                href='/products?filter=Corteva'>CORTEVA</a>
                                </h4>
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0"
                                                href='/products?filter=PBI Gordon'>PBI GORDON</a>
                                </h4>
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0"
                                                href='/products?filter=SePRO'>SEPRO</a></h4>
                        </div>
                        <div style="width:25%"></div>
                </div>
                <div class="row g-0 mt-5 mb-5" *ngIf="this.dotComService.activeSubMenu == 'markets'">
                        <div style="width:37%"></div>
                        <div style="width:15%">
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0" href='/golf'>GOLF
                                                COURSES</a>
                                </h4>
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0" href='/lawn'>LAWN +
                                                LANDSCAPE</a></h4>
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0"
                                                href='/horticulture'>HORTICULTURE</a></h4>
                        </div>
                        <div style="width:15%">
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0" href='/turf'>SPORTS
                                                TURF</a>
                                </h4>
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0" href='/specialty'>SPECIALTY
                                                AG</a></h4>
                        </div>
                        <div style="width:33%"></div>
                </div>
                <div class="row g-0 mt-5 mb-5" *ngIf="this.dotComService.activeSubMenu == 'resources'">
                        <div style="width:37%"></div>
                        <div style="width:15%">
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0"
                                                href='/myharrellslogin'>MYHARRELLS</a></h4>
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0" href='/knowledge'>BLOGS &
                                                MORE</a>
                                </h4>
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0" href='/education'>ONLINE
                                                EDUCATION</a></h4>
                                <!-- <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0" href='/resources'>EVENTS
                                                &
                                                SEMINARS</a></h4> -->
                        </div>
                        <div style="width:15%">
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0" href='/calculators'>TOOLS &
                                                CALCULATORS</a></h4>
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0" href='/forms'>FORMS &
                                                CREDIT
                                                APPLICATIONS</a></h4>
                                <!-- //hidden for now until Sam gets us content 11/15/24 -->
                                <!-- <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0" href='/resources'>BALANCED
                                                APPROACH</a></h4>
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0" href='/resources'>EARLY ORDER
                                                PROGRAM</a></h4> -->
                        </div>
                        <div style="width:33%"></div>
                </div>

                <div class="row g-0 mt-5 mb-5" *ngIf="this.dotComService.activeSubMenu == 'locations'">
                        <div style="width:30%">
                        </div>
                        <div style="width:15%">
                                <h4 *ngFor="let x of allWarehousesFirstThird" style="text-align:left"><a
                                                class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0;"
                                                href="{{'/locations?filter=' + x.name}}">{{x.alt_name | uppercase}}</a>
                                </h4>
                                <!-- <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0;"
                                                href='/locations?filter=Atlanta Warehouse'>ATLANTA, GA</a></h4>
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0;"
                                                href='/locations?filter=Avon Park Warehouse'>AVON PARK, FL</a></h4>
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0;"
                                                href='/locations?filter=Sylacauga Warehouse'>BIRMINGHAM, AL</a></h4>
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0;"
                                                href='/locations?filter=Auburn Warehouse'>BOSTON, MA</a></h4>
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0;"
                                                href='/locations?filter=Charlotte Warehouse'>CHARNOTTE, NC</a></h4>
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0;"
                                                href='/locations?filter=Chattanooga Warehouse'>CHATTANOOGA, TN</a></h4>
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0;"
                                                href='/locations?filter=Lombard Warehouse'>CHICAGO, IL</a></h4>
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0;"
                                                href='/locations?filter=Denver Warehouse'>COLORADO SPRGS, CO</a></h4>
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0;"
                                                href='/locations?filter=Columbus Warehouse'>COLUMBUS, OH</a></h4>
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0;"
                                                href='/locations?filter=Carrollton Warehouse'>DALLAS, TX</a></h4> -->
                        </div>
                        <div style="width:15%">
                                <h4 *ngFor="let x of allWarehousesSecondThird" style="text-align:left"><a
                                                class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0;"
                                                href="{{'/locations?filter=' + x.name}}">{{x.alt_name | uppercase}}</a>
                                </h4>
                                <!-- <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0;"
                                                href='/locations?filter=Livonia Warehouse'>DETROIT, MI</a></h4>
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0;"
                                                href='/locations?filter=New Milford Warehouse'>HARTFORD, CT</a></h4>
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0;"
                                                href='/locations?filter=Houston Warehouse'>HOUSTON, TX</a></h4>
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0;"
                                                href='/locations?filter=Whitestown Warehouse'>INDIANAPOLIS, IN</a></h4>
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0;"
                                                href='/locations?filter=92201'>INDIO, CA</a></h4>
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0;"
                                                href='/locations?filter=33815'>LAKELAND, FL</a></h4>
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0;"
                                                href='/locations?filter=90670'>LOS ANGELES, CA</a></h4>
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0;"
                                                href='/locations?filter=79382'>LUBBOCK, TX</a></h4>
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0;"
                                                href='/locations?filter=33030'>MIAMI, FL</a></h4> -->
                        </div>
                        <div style="width:15%">
                                <h4 *ngFor="let x of allWarehousesLastThird" style="text-align:left"><a
                                                class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0;"
                                                href="{{'/locations?filter=' + x.name}}">{{x.alt_name | uppercase}}</a>
                                </h4>
                                <!-- <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0;"
                                                href='/locations?filter=73179'>OKLAHOMA CITY, OK</a></h4>
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0;"
                                                href='/locations?filter=17402'>PHILADELPHIA, PA</a></h4>
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0;"
                                                href='/locations?filter=85027'>PHOENIX, AZ</a></h4>
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0;"
                                                href='/locations?filter=16001'>PITTSBURGH, PA</a></h4>
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0;"
                                                href='/locations?filter=23231'>RICHMOND, VA</a></h4>
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0;"
                                                href='/locations?filter=78132'>SAN ANTONIO, TX</a></h4>
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0;"
                                                href='/locations?filter=92081'>SAN DIEGO, CA</a></h4>
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0;"
                                                href='/locations?filter=Bay Area - CA Warehouse'>SAN JOSE, CA</a></h4>
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0;"
                                                href='/locations?filter=13032'>SYRACUSE, NY</a></h4>
                                <h4 style="text-align:left"><a class="DIN2014Regular whiteText "
                                                style="font-size:14pt; line-height:1.0;"
                                                href='/locations?filter=97062'>TUALATIN, OR</a></h4> -->
                        </div>
                        <div style="width:25%"></div>
                </div>
        </div>
</div>

<!-- body components -->
<router-outlet (activate)="onActivate($event)" />

<!-- Footer -->
<div class="container-fluid" style="padding-left:0px; padding-right:0px"
        *ngIf="!this.myHarrellsService.onlineOrderingInEffect" (mouseenter)="this.dotComService.DisplaySubMenu('')">


        <!-- desktop view -->
        <div class="d-none d-md-block" *ngIf="!this.myHarrellsService.loggedInMyHarrellsUser">
                <div class="row g-0">
                        <div class="greenBackground pt-5 pb-5" style="width:33%">
                                <a href="/home"><img class="centerHorizontal" style="width:70%"
                                                src="{{this.pageImagePaths + 'harrells-logo-footer.png'}}"
                                                alt="Harrells Footer Logo"></a>
                        </div>
                        <div class="cremeBackground pt-5" style="width:4%"
                                [ngStyle]="{backgroundImage: 'url(' + this.pageImagePaths + 'harrells-texture-dark.png)'}">
                        </div>


                        <div class="cremeBackground pt-5" style="width:19%"
                                [ngStyle]="{backgroundImage: 'url(' + this.pageImagePaths + 'harrells-texture-dark.png)'}">
                                <h4 style="line-height: .5;"><a class="DINNextLTPro-Black blueText"
                                                style="font-size:20px; line-height:1.5em; text-decoration: none !important"
                                                href='/findrep'>FIND YOUR REP</a></h4>
                                <h4 style="line-height: .5;"><a class="DINNextLTPro-Black blueText"
                                                style="font-size:20px; line-height:1.5em; text-decoration: none !important"
                                                href='/products'>PRODUCTS</a></h4>
                                <h4 style="line-height: .5;"><a class="DINNextLTPro-Black blueText"
                                                style="font-size:20px; line-height:1.5em; text-decoration: none !important"
                                                href='/contact'>CONTACT US</a></h4>
                        </div>
                        <div class="cremeBackground pt-5" style="width:19%"
                                [ngStyle]="{backgroundImage: 'url(' + this.pageImagePaths + 'harrells-texture-dark.png)'}">
                                <h2 class="DIN2014Bold greenText"
                                        style="font-size:20px; text-decoration-line: underline">
                                        ABOUT
                                </h2>
                                <h4 style="line-height: .5;"><a class="DIN2014Bold blackText"
                                                style="font-size:19px; line-height:31px; font-weight:600; text-decoration: none !important"
                                                href='/teams'>MEET
                                                HARRELL'S</a></h4>
                                <h4 style="line-height: .5;"><a class="DIN2014Bold blackText"
                                                style="font-size:19px; line-height:31px; font-weight:600; text-decoration: none !important"
                                                href='/careers'>CAREERS</a></h4>
                                <h4 style="line-height: .5;"><a class="DIN2014Bold blackText"
                                                style="font-size:19px; line-height:31px; font-weight:600; text-decoration: none !important"
                                                href='/locations'>LOCATIONS</a></h4>
                        </div>
                        <div class="cremeBackground pt-5" style="width:25%"
                                [ngStyle]="{backgroundImage: 'url(' + this.pageImagePaths + 'harrells-texture-dark.png)'}">
                                <h2 class="DIN2014Bold greenText"
                                        style="font-size:20px; text-decoration-line: underline">
                                        PRESS
                                        RELEASES
                                </h2>
                                <h4 style="line-height: .5;"><a class="DIN2014Bold blackText"
                                                style="font-size:19px; line-height:31px; font-weight:600; text-decoration-line: none !important"
                                                href='/knowledge?id=Press Releases'>PRESS
                                                RELEASES</a></h4>
                                <!-- <h4 style="line-height: .5;"><a class="DIN2014Bold blackText"
                                                style="font-size:19px; line-height:31px; font-weight:600; text-decoration-line: none !important"
                                                href='/resources'>MEDIA
                                                KIT</a></h4> -->
                        </div>
                </div>

                <div class="row g-0">

                        <div class="greenBackground d-none d-md-block" style="width:33%; position:relative">
                                <h6 class="d-none d-md-block DIN2014Regular whiteText"
                                        style="position:relative; margin-top:-20px;font-size:16px; line-height:24px; margin-left:20%; width:70%;">
                                        In addition to being the nation’s largest distributor of branded
                                        fungicides,
                                        herbicides,
                                        and
                                        insecticides, Harrell’s produces custom-blended fertilizers, specialty
                                        liquids,
                                        and
                                        wetting agents.
                                        Additionally, Harrell’s is the exclusive US owner, formulator, and
                                        distributor
                                        of all
                                        POLYON® branded
                                        products.</h6>


                                <h3 class="text-center mt-3" style="width:100%; position:absolute; bottom:0">
                                        <a class="DINNextLTPro-Black lightBlueBackground blueText"
                                                style="border-top-left-radius: 15px 15px; border-top-right-radius: 15px 15px; font-size:20px; font-weight:900; padding:8px; text-decoration: none !important"
                                                href='https://teamharrells.com' target="_blank">TEAM HARRELL'S</a>
                                </h3>

                                <!-- <h6 class="Minion-Pro whiteText mt-3 d-none d-md-block" style="text-align: center;">TEAM
                                        HARRELL'S</h6> -->
                        </div>
                        <div class="cremeBackground pt-5" style="width:4%"
                                [ngStyle]="{backgroundImage: 'url(' + this.pageImagePaths + 'harrells-texture-dark.png)'}">
                        </div>
                        <div class="pt-3" style="width:19%; padding-bottom:50px"
                                [ngStyle]="{backgroundImage: 'url(' + this.pageImagePaths + 'harrells-texture-dark.png)'}">
                                <h2 class="DIN2014Bold greenText"
                                        style="font-size:20px; text-decoration-line: underline">
                                        CUSTOMER <br>
                                        RESOURCES</h2>
                                <h4 style="line-height: .5;"><a class="DIN2014Bold blackText"
                                                style="font-size:19px; line-height:31px; font-weight:600; text-decoration: none !important"
                                                href='/myharrellslogin'>MYHARRELL'S</a></h4>
                                <h4 style="line-height: .5;"><a class="DIN2014Bold blackText"
                                                style="font-size:19px; line-height:31px; font-weight:600; text-decoration: none !important"
                                                href='/calculators'>TOOLS</a></h4>
                                <!-- <h4 style="line-height: .5;"><a class="DIN2014Bold blackText"
                                                style="font-size:19px; line-height:31px; font-weight:600; text-decoration: none !important"
                                                href='/resources'>EVENTS &
                                                SEMINARS</a></h4> -->
                                <h4 style="line-height: .5;"><a class="DIN2014Bold blackText"
                                                style="font-size:19px; line-height:31px; font-weight:600; text-decoration: none !important"
                                                href='/forms'>FORMS</a></h4>
                                <h4 style="line-height: .5;"><a class="DIN2014Bold blackText"
                                                style="font-size:19px; line-height:31px; font-weight:600; text-decoration: none !important"
                                                href='/knowledge'>KNOWLEDGE</a></h4>
                        </div>
                        <div class="cremeBackground  pt-3" style="width:19%; padding-bottom:50px"
                                [ngStyle]="{backgroundImage: 'url(' + this.pageImagePaths + 'harrells-texture-dark.png)'}">
                                <h2 class="DIN2014Bold greenText"
                                        style="font-size:20px; text-decoration-line: underline">
                                        MORE
                                        INFO</h2>
                                <!-- <h4 style="line-height: .5;"><a class="DIN2014Bold blackText"
                                                style="font-size:19px; line-height:31px; font-weight:600; text-decoration: none !important"
                                                href='/myharrellslogin'>MEET
                                                MYHARRELL'S</a></h4> -->
                                <!-- <h4 style="line-height: .5;"><a class="DIN2014Bold blackText"
                                                style="font-size:19px; line-height:31px; font-weight:600; text-decoration: none !important"
                                                href='/resources'>ACCESSIBILITY</a></h4> -->
                                <h4 style="line-height: .5;"><a class="DIN2014Bold blackText"
                                                style="font-size:19px; line-height:31px; font-weight:600; text-decoration: none !important"
                                                href="{{filePaths + 'Harrells_Privacy_Policy.pdf'}}"
                                                target="_blank">PRIVACY
                                                POLICY</a></h4>
                                <h4 style="line-height: .5;"><a class="DIN2014Bold blackText"
                                                style="font-size:19px; line-height:31px; font-weight:600; text-decoration: none !important"
                                                href="{{filePaths + 'harrells_general_terms_and_conditions_domestic.pdf'}}"
                                                target="_blank">TERMS & CONDITIONS</a></h4>
                        </div>

                        <div class="cremeBackground  pt-3" style="width:25%; padding-bottom:50px"
                                [ngStyle]="{backgroundImage: 'url(' + this.pageImagePaths + 'harrells-texture-dark.png)'}">
                                <h2 class="DIN2014Bold greenText"
                                        style="font-size:20px; text-decoration-line: underline">
                                        STAY
                                        EQUIPPED
                                </h2>
                                <h6 class="DIN2014Regular blackText"
                                        style="font-size:19px; width:75%;line-height: 29px; font-weight:400">
                                        Never stop learning.
                                        Access FREE continuing education courses from Harrell’s.</h6>
                                <h6 class="mt-4"><a class="DIN2014Bold greenBackground whiteText"
                                                style="font-size:12pt; padding:8px; text-decoration: none !important"
                                                href='/education'>LET'S GROW</a></h6>
                        </div>
                        <!-- <div class="cremeBackground  pt-3 pb-5"  style="width:22%"
                                style="background-size: cover; background-position:center"
                                [ngStyle]="{backgroundImage: 'url(' + this.pageImagePaths + 'harrells-texture-dark.png)'}">
                                <h2 class="DIN2014Bold greenText"
                                        style="font-size:20px; margin-left:20%; text-decoration-line: underline">
                                        STAY
                                        EQUIPPED
                                </h2>
                                <h6 class="DIN2014Regular blackText"
                                        style="font-size:19px; margin-left:20%; width:50%;line-height: 24px">
                                        Never stop learning.
                                        Access FREE continuing education courses from Harrell’s.</h6>
                                <h6 class="mt-3"><a class="DIN2014Bold greenBackground whiteText"
                                                style="font-size:12pt; margin-left:20%; padding:8px; text-decoration: none !important"
                                                href='/findrep'>LET'S GROW</a></h6>
                        </div> -->
                </div>
        </div>
        <!-- mobile view  -->
        <!-- not showing when showing myharrells -->
        <div class="d-xs-block d-md-none" *ngIf="!this.myHarrellsService.loggedInMyHarrellsUser">
                <div class="row g-0">
                        <!-- <div class="col-12 greenBackground pt-5 pb-5">
                                <a href="/home"><img class="centerHorizontal" style="width:70%"
                                                src="{{this.pageImagePaths + 'harrells-logo-footer.png'}}"
                                                alt="Harrells Footer Logo"></a>
                        </div> -->

                        <div class="cremeBackground pt-5"
                                [ngStyle]="{backgroundImage: 'url(' + this.pageImagePaths + 'harrells-texture-dark.png)'}">
                                <h4><a class="DINNextLTPro-Black blueText"
                                                style="font-size:20px; line-height:1.5em; margin-left:20%; text-decoration: none !important"
                                                href='/findrep'>FIND YOUR REP</a></h4>
                                <h4><a class="DINNextLTPro-Black blueText"
                                                style="font-size:20px; line-height:1.5em; margin-left:20%; text-decoration: none !important"
                                                href='/products'>PRODUCTS</a></h4>
                                <h4><a class="DINNextLTPro-Black blueText"
                                                style="font-size:20px; line-height:1.5em; margin-left:20%; text-decoration: none !important"
                                                href='/contact'>CONTACT US</a></h4>
                        </div>

                        <div class="cremeBackground pt-3"
                                [ngStyle]="{backgroundImage: 'url(' + this.pageImagePaths + 'harrells-texture-dark.png)'}">
                                <h2 class="DIN2014Bold greenText"
                                        style="font-size:20px; margin-left:20%; text-decoration-line: underline">
                                        CUSTOMER
                                        RESOURCES</h2>
                                <h4><a class="DIN2014Bold blackText"
                                                style="font-size:19px; line-height:31px; margin-left:20%; font-weight:600; text-decoration: none !important"
                                                href='/myharrellslogin'>MYHARRELL'S</a></h4>
                                <h4><a class="DIN2014Bold blackText"
                                                style="font-size:19px; line-height:31px; margin-left:20%; font-weight:600; text-decoration: none !important"
                                                href='/calculators'>TOOLS</a></h4>
                                <!-- <h4><a class="DIN2014Bold blackText"
                                                style="font-size:19px; line-height:31px; font-weight:600; text-decoration: none !important"
                                                href='/resources'>EVENTS &
                                                SEMINARS</a></h4> -->
                                <h4><a class="DIN2014Bold blackText"
                                                style="font-size:19px; line-height:31px; margin-left:20%; font-weight:600; text-decoration: none !important"
                                                href='/forms'>FORMS</a></h4>
                                <h4><a class="DIN2014Bold blackText"
                                                style="font-size:19px; line-height:31px; margin-left:20%; font-weight:600; text-decoration: none !important"
                                                href='/knowledge'>KNOWLEDGE</a></h4>
                        </div>

                        <div class="cremeBackground pt-3"
                                [ngStyle]="{backgroundImage: 'url(' + this.pageImagePaths + 'harrells-texture-dark.png)'}">
                                <h2 class="DIN2014Bold greenText"
                                        style="font-size:20px; margin-left:20%; text-decoration-line: underline">
                                        ABOUT
                                </h2>
                                <h4><a class="DIN2014Bold blackText"
                                                style="font-size:19px; line-height:31px; margin-left:20%; font-weight:600; text-decoration: none !important"
                                                href='/teams'>MEET
                                                HARRELL'S</a></h4>
                                <h4><a class="DIN2014Bold blackText"
                                                style="font-size:19px; line-height:31px; margin-left:20%; font-weight:600; text-decoration: none !important"
                                                href='/careers'>CAREERS</a></h4>
                                <h4><a class="DIN2014Bold blackText"
                                                style="font-size:19px; line-height:31px; margin-left:20%; font-weight:600; text-decoration: none !important"
                                                href='/locations'>LOCATIONS</a></h4>
                        </div>

                        <div class="cremeBackground  pt-3"
                                [ngStyle]="{backgroundImage: 'url(' + this.pageImagePaths + 'harrells-texture-dark.png)'}">
                                <h2 class="DIN2014Bold greenText"
                                        style="font-size:20px; margin-left:20%; text-decoration-line: underline">
                                        MORE
                                        INFO</h2>
                                <!-- <h4><a class="DIN2014Bold blackText"
                                                style="font-size:19px; line-height:31px; margin-left:20%; font-weight:600; text-decoration: none !important"
                                                href='/myharrellslogin'>MEET
                                                MYHARRELL'S</a></h4> -->
                                <!-- <h4><a class="DIN2014Bold blackText"
                                                style="font-size:19px; line-height:31px; margin-left:20%; font-weight:600; text-decoration: none !important"
                                                href='/resources'>ACCESSIBILITY</a></h4> -->
                                <h4><a class="DIN2014Bold blackText"
                                                style="font-size:19px; line-height:31px; margin-left:20%; font-weight:600; text-decoration: none !important"
                                                href="{{filePaths + 'Harrells_Privacy_Policy.pdf'}}"
                                                target="_blank">PRIVACY
                                                POLICY</a></h4>
                                <h4><a class="DIN2014Bold blackText"
                                                style="font-size:19px; line-height:31px; margin-left:20%; font-weight:600; text-decoration: none !important"
                                                href="{{filePaths + 'harrells_general_terms_and_conditions_domestic.pdf'}}"
                                                target="_blank">TERMS & CONDITIONS</a></h4>
                        </div>

                        <div class="cremeBackground pt-3"
                                [ngStyle]="{backgroundImage: 'url(' + this.pageImagePaths + 'harrells-texture-dark.png)'}">
                                <h2 class="DIN2014Bold greenText"
                                        style="font-size:20px; margin-left:20%; text-decoration-line: underline">
                                        PRESS
                                        RELEASES
                                </h2>
                                <h4><a class="DIN2014Bold blackText"
                                                style="font-size:19px; line-height:31px; margin-left:20%; font-weight:600"
                                                href='/knowledge?id=Press Releases'>PRESS
                                                RELEASES</a></h4>
                                <!-- <h4><a class="DIN2014Bold blackText"
                                                style="font-size:19px; line-height:31px; margin-left:20%; font-weight:600; text-decoration-line: underline"
                                                href='/resources'>MEDIA
                                                KIT</a></h4> -->
                        </div>

                        <div class="col-lg-3 cremeBackground  pt-3 pb-5"
                                style="background-size: cover; background-position:center"
                                [ngStyle]="{backgroundImage: 'url(' + this.pageImagePaths + 'harrells-texture-dark.png)'}">
                                <h2 class="DIN2014Bold greenText"
                                        style="font-size:20px; margin-left:20%; text-decoration-line: underline">
                                        STAY
                                        EQUIPPED
                                </h2>
                                <h6 class="DIN2014Regular blackText"
                                        style="font-size:19px; margin-left:20%; width:50%;line-height: 29px">
                                        Never stop learning.
                                        Access FREE continuing education courses from Harrell’s.</h6>
                                <h6 class="mt-3"><a class="DIN2014Bold greenBackground whiteText"
                                                style="font-size:12pt; margin-left:20%; padding:8px; text-decoration: none !important"
                                                href='/education'>LET'S GROW</a></h6>
                        </div>

                </div>
        </div>


        <!-- social media icons footer row -->
        <!-- not showing when in myharrells  -->
        <div class="blueBackground"
                *ngIf="!(this.myHarrellsService.loggedInMyHarrellsUser)"
                style="padding-right: 30px;padding-left: 30px;">

                <div class="col-12  pt-5 pb-5"
                        *ngIf="(this.myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm')">
                        <a href="/home"><img class="centerHorizontal" style="width:70%"
                                        src="{{this.pageImagePaths + 'harrells-logo-footer.png'}}"
                                        alt="Harrells Footer Logo"></a>
                </div>

                <div class="row g-0">
                        <div class="col pt-2" style="padding-right:0px">
                                <a href='https://youtube.com/user/HarrellsLLC' target="_blank"><img
                                                style="margin-right:5px; padding-top:3%; padding-bottom:3%; width:25px"
                                                src="{{this.pageImagePaths + 'harrells-youtube-icon.png'}}"
                                                alt="youtube icon"></a>
                                <a href='https://facebook.com/harrellsllc' target="_blank"><img
                                                style="margin-right:5px; padding-top:3%; padding-bottom:3%; width:25px"
                                                src="{{this.pageImagePaths + 'harrells-facebook-icon.png'}}"
                                                alt="facebook icon"></a>
                                <a href='https://instagram.com/harrellsllc' target="_blank"><img
                                                style="margin-right:5px; padding-top:3%; padding-bottom:3%; width:25px"
                                                src="{{this.pageImagePaths + 'harrells-instagram-icon.png'}}"
                                                alt="instagram icon"></a>
                                <a href='https://twitter.com/harrellsllc' target="_blank"><img
                                                style="margin-right:5px; padding-top:3%; padding-bottom:3%; width:25px"
                                                src="{{this.pageImagePaths + 'harrells-x-icon.png'}}"
                                                alt="twitter icon"></a>
                                <a href='https://linkedin.com/company/815218' target="_blank"><img
                                                style="margin-right:5px; padding-top:3%; padding-bottom:3%; width:25px"
                                                src="{{this.pageImagePaths + 'harrells-linkedin-icon.png'}}"
                                                alt="linkedin icon"></a>
                        </div>
                        <div class="col footerBarHarrellsOuter">
                                <h6 class="DIN2014Regular whiteText"
                                        style="float:right; font-size:16px;text-align: right;line-height:31px">
                                        &copy;
                                        Harrell's, LLC 2025</h6>
                        </div>
                </div>
                <!-- <div>
                        <h6 style="color:white">6/5/2025</h6>
                </div> -->

        </div>

</div>